<template>
  <!-- Global notification live region, render this permanently at the end of the document -->
  <Teleport to="body">
    <div
      aria-live="assertive"
      class="pointer-events-none fixed inset-0 flex items-end px-4 py-6 sm:items-start sm:p-6"
    >
      <div class="flex w-full flex-col items-center space-y-4 sm:items-end">
        <!-- Notification panel, dynamically insert this into the live region when it needs to be displayed -->
        <transition
          enterActiveClass="transform ease-out duration-300 transition"
          enterFromClass="translate-y-2 opacity-0 sm:translate-y-0 sm:translate-x-2"
          enterToClass="translate-y-0 opacity-100 sm:translate-x-0"
          leaveActiveClass="transition ease-in duration-100"
          leaveFromClass="opacity-100"
          leaveToClass="opacity-0"
        >
          <div
            v-if="show"
            class="pointer-events-auto w-full max-w-sm rounded-lg bg-white shadow-lg ring-1 ring-black/5"
          >
            <div class="p-4">
              <div class="flex items-start">
                <div class="shrink-0">
                  <slot name="icon">
                    <CheckCircleIcon
                      class="size-6 text-green-400"
                      aria-hidden="true"
                    />
                  </slot>
                </div>
                <div class="ml-3 w-0 flex-1 pt-0.5">
                  <p class="text-sm font-medium text-gray-900">
                    {{ title }}
                  </p>
                  <p class="mt-1 text-sm text-gray-500">
                    {{ message }}
                  </p>
                </div>
                <div class="ml-4 flex shrink-0">
                  <button
                    type="button"
                    class="inline-flex rounded-md bg-white text-gray-400 hover:text-gray-500 focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 focus:outline-hidden"
                    @click="show = false"
                  >
                    <span class="sr-only">Close</span>
                    <XMarkIcon class="size-5" aria-hidden="true" />
                  </button>
                </div>
              </div>
            </div>
          </div>
        </transition>
      </div>
    </div>
  </Teleport>
</template>

<script setup>
import { ref } from 'vue'
import { CheckCircleIcon } from '@heroicons/vue/24/outline'
import { XMarkIcon } from '@heroicons/vue/20/solid'

defineProps({
  title: {
    type: String,
    default: '',
  },
  message: {
    type: String,
    default: '',
  },
})

const show = ref(true)
</script>
